const initialThemeLight = () => {
  const json = window?.config?.REACT_APP_JSON_INITIAL_THEME_LIGHT;
  return json ? JSON.parse(json) : null;
};
const initialThemeDark = () => {
  const json = window?.config?.REACT_APP_JSON_INITIAL_THEME_DARK;
  return json ? JSON.parse(json) : null;
};

export { initialThemeLight, initialThemeDark };
